import React from "react";
import { ModeRendererProps } from "./types";

export function SpiralMode({ brand }: ModeRendererProps) {
  return (
    <g transform="translate(397 540)">
      <circle r="340" fill="url(#spiralFade)" />
      {Array.from({ length: 180 }).map((_, i) => {
        const t = i * 0.11;
        const rr = 10 + t * 3.2;
        const ang = t * 26;
        const x = rr * Math.cos((Math.PI / 180) * ang);
        const y = rr * Math.sin((Math.PI / 180) * ang);
        const col = i % 3 === 0 ? brand.aqua : i % 3 === 1 ? brand.violet : brand.amber;
        return <circle key={i} cx={x} cy={y} r={i % 5 === 0 ? 1.9 : 1.2} fill={col} opacity={0.8 - i * 0.003} />;
      })}
    </g>
  );
}
